"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Autocomplete_1 = __importDefault(require("@mui/material/Autocomplete"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const TextField_1 = __importDefault(require("@mui/material/TextField"));
const style_1 = require("./style");
function AutocompleteField({ options, name, value, id, disabled, onChange, error, label, placeholder, getOptionLabel, helperText, fullWidth, size, autocompleteStyles, inputStyles, required, onBlur, isOptionEqualToValue, onFocus, isLoading, readOnly, inputValue = "", onChangeInput, filterOptions, }) {
    const style = (0, style_1.StyledAutocomplete)(readOnly);
    return (react_1.default.createElement(Autocomplete_1.default, { id: id, value: value, fullWidth: fullWidth, filterOptions: filterOptions, disablePortal: true, readOnly: readOnly, onInputChange: onChangeInput, onChange: onChange, isOptionEqualToValue: isOptionEqualToValue, size: size, getOptionLabel: getOptionLabel, options: options, sx: {
            ...autocompleteStyles,
            ...style,
            option: { textTransform: "capitalize" },
        }, disabled: disabled, renderInput: (params) => (react_1.default.createElement(TextField_1.default, { ...params, InputLabelProps: {
                shrink: false,
                focused: false,
            }, InputProps: {
                ...params.InputProps,
                value: inputValue,
                endAdornment: (react_1.default.createElement(react_1.default.Fragment, null,
                    isLoading ? (react_1.default.createElement(CircularProgress_1.default, { color: "inherit", size: 20 })) : null,
                    params.InputProps.endAdornment)),
            }, label: label, onBlur: onBlur, sx: inputStyles, onFocus: onFocus, name: name, required: required, placeholder: placeholder, error: error, helperText: helperText, disabled: disabled })) }));
}
exports.default = AutocompleteField;
